import { Typography } from '@mui/material';
import React from 'react';

import {
  FeatureFlagItemContainer,
  FeatureFlagText,
  FeatureFlagToggle,
} from '@/backoffice/features/tenants/components/feature-flags/feature-flags.styled';
import { TFeatureFlagItemProps } from '@/backoffice/features/tenants/components/feature-flags/feature-flags.types';
import { FormToggle } from '@/shared/components/ui/form/components/form-toggle/form-toggle';

export const FeatureFlagItem: React.FC<TFeatureFlagItemProps> = ({
  index,
  title,
  description,
}) => (
  <FeatureFlagItemContainer>
    <FeatureFlagText>
      <Typography variant="p6" color="primary">
        {title}
      </Typography>
      {description && (
        <Typography variant="p8" color="textSecondary">
          {description}
        </Typography>
      )}
    </FeatureFlagText>
    <FeatureFlagToggle>
      <FormToggle name={`flags.${index}.isEnabled`} />
    </FeatureFlagToggle>
  </FeatureFlagItemContainer>
);
